import request from '@/utils/request'

//本证购买报备
export function getGmbb(gmzbh) {
  return request({
    method: 'get',
    url: '/yzdservice/api/xkzbb/bzGmbb?gmzbh=' + gmzbh
  })
}

//本证销售报备
export function getXsbb(gmzbh) {
  return request({
    method: 'get',
    url: '/yzdservice/api/xkzbb/bzXsbb?gmzbh=' + gmzbh
  })
}

//本证运输报备
export function getYsbb(gmzbh) {
  return request({
    method: 'get',
    url: '/yzdservice/api/xkzbb/bzYsbb?yszbh=' + gmzbh
  })
}

//获取购买证图片
export function getXkzImg(xkzbh, xkzLx) {
  return request({
    method: 'get',
    url: '/yzdservice/api/xkzbb/getXkzImg?xkzbh=' + xkzbh + '&xkzLx=' + xkzLx
  })
}
